import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import { formatRoute } from 'react-router-named-routes'
import { LanguageConsumer } from '../../context/LanguageContext'
import { SubmissionViewProvider } from '../../context/SubmissionViewContext'
import SingleSubmissionPageContent from '../../components/SingleSubmissionPageContent'
import Configuration from '../../Services/Api/Configuration'

const Submission = ({isMs}) => {
  const intl = useIntl()
  let { id } = useParams()

  return (
    !!id ? <>
        <SEO title={intl.formatMessage({ id: 'Page.invoice.submission.title' }, { uuid: id })}
             pathname={window.location.origin + formatRoute(NamedRoutes.submission, { id: id })}
             titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
             description={intl.formatMessage({ id: 'Page.invoice.submission.title' }, { uuid: id })}
        />

        <AccountLayout permission={Configuration.permissions.invoice.view} content={
          <LanguageConsumer>
            {({ locale }) => (
              <SubmissionViewProvider isMs={isMs} id={id}>
                <SingleSubmissionPageContent isMs={isMs} locale={locale}/>
              </SubmissionViewProvider>
            )}
          </LanguageConsumer>
        }/>
      </>
      :
      <Redirect to={NamedRoutes.invoices}/>
  )
}

export default Submission
